import './utensils_input.css';
import { useEffect, useState } from 'react';
import { useServer } from '../../context/ServerContext';
import { askForUtensilsEndpoints, cartEndpoints } from '../../env';
import { useCart } from '../../context/CartContext';
import { SpinnerLoader } from '../SpinnerLoader/SpinnerLoader';

export const UtensilsInput = () => {
    //HOOKS
    const { getRequest, postRequest } = useServer();
    const { cart, getCartToken, setCart } = useCart();

    //STATES
    const [setting, setSetting] = useState(null);
    const [utensils, setUtensils] = useState(false);

    const [loading, setLoading] = useState(false);

    //FUNCTIONS
    const getUtensilsSettings = () => {
        getRequest(askForUtensilsEndpoints.get, {}, ([status, res]) => {
            if (status)
            {
                setSetting(res);
            }
        });
    }

    const update = (need) => {
        setLoading(true);

        const data = {
            cart_token: getCartToken(),
            need_utensils: need,
        }

        postRequest(cartEndpoints.update_utensils, data, ([status, res]) => {
            setLoading(false);
            if (status)
            {
                setUtensils(res.cart.options.include_utensils);
                setCart(res.cart);
            }
        });
    }

    //EFFECTS
    useEffect(() => {
        getUtensilsSettings();
    }, []);

    useEffect(() => {
        if (cart != null)
        {
            setUtensils(cart.options.include_utensils);
        }
    }, [cart]);

    return (
        <>
            <div class={setting?.enable ? "utensils_container active" : "utensils_container"} id="utensils_container">
                <hr class="firts_hr" />
                <div>
                    <svg viewBox="0 0 624 801" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M235.599 37.3047V207.959C235.599 218.897 226.761 227.711 215.872 227.711H210.599C199.709 227.711 190.847 218.897 190.847 207.959V36.5234C190.847 8.39844 171.927 0 153.786 0C135.645 0 116.725 8.39844 116.725 36.5234V207.959C116.725 218.897 107.863 227.711 96.9735 227.711H91.7001C80.811 227.711 71.9735 218.897 71.9735 207.959V37.3047C71.9735 -13.0375 0.195407 -11.3281 0.195407 37.8656C0.195407 96.7766 0.195407 200.83 0.195407 200.83C-0.146781 291.308 21.4845 314.819 57.1782 343.017C85.9626 365.722 110.547 378.734 110.547 435.131V797.925H197.022V435.131C197.022 378.734 221.606 365.722 250.391 343.017C286.108 314.819 307.716 291.308 307.374 200.83C307.374 200.83 307.374 96.7766 307.374 37.8656C307.375 -11.3281 235.599 -13.0375 235.599 37.3047Z" fill="white"></path>
                        <path d="M513.919 54.2969C495.56 105.786 442.703 226.416 439.358 332.959C434.181 498.341 535.525 473.878 537.331 582.227V798.927H623.391L623.806 800.002C623.806 800.002 623.806 799.563 623.806 798.927C623.806 784.449 623.806 612.013 623.806 436.109C623.806 262.111 623.806 84.8641 623.806 54.2985C623.806 -8.49681 542.506 -25.8296 513.919 54.2969Z" fill="white"></path>
                    </svg>
                    <h2>
                        Include utensils
                    </h2>
                    <input type="checkbox" checked={utensils} onChange={() => {update(!utensils);setUtensils(!utensils);}} />
                    {
                        loading && (
                            <div className='loader'>
                                <SpinnerLoader />
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    );
}